import type { DriveStep } from 'driver.js';

export const customerProfileTourId = 'customer:profile';

export const customerProfileSteps: DriveStep[] = [
  {
    element: '[data-tour="customer:nav-profile"]',
    popover: {
      title: 'Профиль',
      description: 'Раздел профиля — ваши данные и настройки.',
    },
  },
  {
    element: '[data-tour="customer:profile-info"]',
    popover: {
      title: 'Информация',
      description:
        'Информация о вашем аккаунте: имя, email, привязанный пункт выдачи.',
    },
  },
  {
    element: '[data-tour="customer:telegram-connect"]',
    popover: {
      title: 'Telegram',
      description:
        'Подключите Telegram-бота, чтобы получать мгновенные уведомления о статусе заказов прямо в мессенджер.',
    },
  },
  {
    element: '[data-tour="customer:help-btn"]',
    popover: {
      title: 'Помощь',
      description: 'Помощь.',
    },
  },
];
